import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import PostControls from 'flarum/forum/utils/PostControls';
import Button from 'flarum/common/components/Button';
export default () => {
  const createPoll = post => app.modal.show(() => import(/* webpackChunkName: 'forum/components/CreatePollModal', webpackMode: 'lazy-once' */ './components/CreatePollModal'), {
    onsubmit: data => app.store.createRecord('polls').save({
      ...data,
      relationships: {
        post
      }
    }, {
      data: {
        include: 'options,myVotes,myVotes.option'
      }
    }).then(poll => {
      // @ts-ignore
      post.rawRelationship('polls')?.push?.({
        type: 'polls',
        id: poll.id()
      });
      return poll;
    })
  });
  extend(PostControls, 'moderationControls', function (items, post) {
    // @ts-ignore
    if (!post.isHidden() && post.canStartPoll()) {
      items.add('addPoll', m(Button, {
        icon: "fas fa-poll",
        onclick: createPoll.bind(this, post)
      }, app.translator.trans('fof-polls.forum.moderation.add')));
    }
  });
};